/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_Area_MaxInputs */

const cs_requirements_area_max = /** @type {(inputs: Requirements_Area_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plocha do (m²)`)
};

const en_requirements_area_max = /** @type {(inputs: Requirements_Area_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area max (m²)`)
};

/**
* | output |
* | --- |
* | "Area max (m²)" |
*
* @param {Requirements_Area_MaxInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_area_max = /** @type {((inputs?: Requirements_Area_MaxInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_Area_MaxInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_area_max(inputs)
	return cs_requirements_area_max(inputs)
});